var map = {
  "./desktop/index.js": [
    "58661",
    9,
    "9598",
    "76225",
    "62815",
    "80169",
    "47387",
    "3199",
    "88565",
    "77996",
    "50437",
    "27174",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "6260",
    "50279",
    "13440",
    "99638"
  ],
  "./desktop/TrendingArticles": [
    "24977",
    9,
    "9598",
    "47387",
    "3199",
    "88565",
    "27174",
    "6260",
    "50279",
    "13440",
    "79365"
  ],
  "./desktop/index": [
    "58661",
    9,
    "9598",
    "76225",
    "62815",
    "80169",
    "47387",
    "3199",
    "88565",
    "77996",
    "50437",
    "27174",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "6260",
    "50279",
    "13440",
    "99638"
  ],
  "./mobile/TrendingArticles": [
    "33611",
    9,
    "9598",
    "47387",
    "88565",
    "6532",
    "83274",
    "2845",
    "53593"
  ],
  "./desktop/TrendingArticles.js": [
    "24977",
    9,
    "9598",
    "47387",
    "3199",
    "88565",
    "27174",
    "6260",
    "50279",
    "13440",
    "79365"
  ],
  "./mobile/TrendingArticles.js": [
    "33611",
    9,
    "9598",
    "47387",
    "88565",
    "6532",
    "83274",
    "2845",
    "53593"
  ],
  "./desktop/TrendingArticles.scss": [
    "19447",
    7,
    "50774"
  ],
  "./mobile": [
    "60513",
    9,
    "9598",
    "70190",
    "47387",
    "3199",
    "88565",
    "77996",
    "68454",
    "44944",
    "17189",
    "6532",
    "83274",
    "2845",
    "4578"
  ],
  "./desktop": [
    "58661",
    9,
    "9598",
    "76225",
    "62815",
    "80169",
    "47387",
    "3199",
    "88565",
    "77996",
    "50437",
    "27174",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "6260",
    "50279",
    "13440",
    "99638"
  ],
  "./desktop/": [
    "58661",
    9,
    "9598",
    "76225",
    "62815",
    "80169",
    "47387",
    "3199",
    "88565",
    "77996",
    "50437",
    "27174",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "6260",
    "50279",
    "13440",
    "99638"
  ],
  "./mobile/": [
    "60513",
    9,
    "9598",
    "70190",
    "47387",
    "3199",
    "88565",
    "77996",
    "68454",
    "44944",
    "17189",
    "6532",
    "83274",
    "2845",
    "4578"
  ],
  "./mobile/TrendingArticles.scss": [
    "52721",
    7,
    "61850"
  ],
  "./mobile/index": [
    "60513",
    9,
    "9598",
    "70190",
    "47387",
    "3199",
    "88565",
    "77996",
    "68454",
    "44944",
    "17189",
    "6532",
    "83274",
    "2845",
    "4578"
  ],
  "./mobile/index.js": [
    "60513",
    9,
    "9598",
    "70190",
    "47387",
    "3199",
    "88565",
    "77996",
    "68454",
    "44944",
    "17189",
    "6532",
    "83274",
    "2845",
    "4578"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 30595;
module.exports = __rspack_async_context;
